import normalizeUrl from "src/features/HomepageCarouselBanners/utils/normalizeUrl";

const adaptEditFullpageTakeoverForm = (
	id: number,
	data: BannerFormState
): CarouselBanner => {
	const result = {
		id,
		variant: "standard",
		template: data.bannerType,
		banner_type: "internal" as "internal" | "sponsored",
		button_style: data.steps[3].fields![0].givenAnswer as BannerVariant,
		button_text: data.steps[3].fields![1].givenAnswer,
		button_link: normalizeUrl(data.steps[3].fields![2].givenAnswer),
		button_visible: data.steps[3].isStepDisabled ? false : true,
		name: data.steps[0].fields![0].givenAnswer,
		image_portrait_uuid:
			data.steps[1].fields && data.steps[1].fields[0].givenAnswer
				? data.steps[1].fields[0].givenAnswer
				: null,
		image_landscape_uuid:
			data.steps[2].fields && data.steps[2].fields[0].givenAnswer
				? data.steps[2].fields[0].givenAnswer
				: null,
		published: false
	} as CarouselBanner;

	return result;
};

export default adaptEditFullpageTakeoverForm;
